import { useLocales } from 'expo-localization'
import { compact, intersection, map, some } from 'lodash'
import { useMemo } from 'react'
import { Platform } from 'react-native'

const imperialRegions = [
  'US', // United States
  'GB', // United Kingdom
  'LR', // Liberia
  'MM', // Myanmar/Burma
  'AS', // American Samoa
  'GU', // Guam
  'MP', // Northern Mariana Islands
  'PR', // Puerto Rico
  'VI', // US Virgin Islands
  'PW' // Palau
]

export const useHasMetricLocale = () => {
  const locales = useLocales()

  return useMemo(() => {
    if (Platform.OS === 'web') {
      // web doesn't have access to measurement system, so we'll infer it based on the browser's languages. if the user
      // does not have a language with a region that is in the imperial regions list, consider them metric
      return (
        intersection(
          compact(
            map(navigator.languages, (language) => {
              try {
                const locale = new Intl.Locale(language)
                return locale.region
              } catch {
                return undefined
              }
            })
          ),
          imperialRegions
        ).length === 0
      )
    }

    return some(locales, ({ measurementSystem }) => measurementSystem === 'metric')
  }, [locales])
}
